import type { ReactNode } from 'react';
import { tCalendar } from '../../lib/calendar-i18n';
import type { FriendlyError } from './calendarErrors';

/**
 * 캘린더 에러 안내 — 제목 / 원인 / 해결 방법 세 줄 (2026-09-15).
 * 오류 코드는 사용자에게 보이지 않는다(사용자 지시) — FriendlyError.code 는 화면 분기용으로만 쓴다.
 *
 * 바깥 상자(색·여백)는 표시 지점이 원래 쓰던 클래스를 그대로 받는다 — 모달 안 붉은 줄, 상단 배너,
 * 사이드바 등 자리마다 모양이 달라서다. 이 컴포넌트는 안쪽 줄 구성만 통일한다.
 * children — 재시도 버튼처럼 안내 옆에 붙는 동작.
 */
export function CalendarErrorNotice({
  error, className, children,
}: { error: FriendlyError; className: string; children?: ReactNode }) {
  return (
    <div className={`${className} cal-errnote`} role="alert">
      <div className="cal-errnote__body">
        <strong className="cal-errnote__title">{error.title}</strong>
        <p className="cal-errnote__line">
          <span className="cal-errnote__label">{tCalendar('calendar.error.label.reason')}</span>
          <span>{error.reason}</span>
        </p>
        <p className="cal-errnote__line">
          <span className="cal-errnote__label">{tCalendar('calendar.error.label.action')}</span>
          <span>{error.action}</span>
        </p>
      </div>
      {children}
    </div>
  );
}
